<!-- Start Content-->
<div class="container-fluid">
    <div class="row my-1">
        <div class="col-md-12">
            <div class="userTables">
  
                <div class="row">
                    <div class="col-12">
                        <h2>icasino setting</h2>
                        <accordion [closeOthers]="true" *ngIf="data">
                            <accordion-group class="accordionUI" [isOpen]="i == 0" *ngFor="let item of data?.user_configs;let i=index;trackBy:trackByIndex;">
                                <button class="btn btn-link shadow-none" accordion-heading type="button">
                                    ICasino 
                                </button>
                                <form id="" class="formUi" action="" method="post">
                                    <div class="form-row">
        
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Min Bet:</label>
                                                <input type="number" name="min_bet{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.min_bet" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Max Bet:</label>
                                                <input type="number" name="max_bet{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_bet" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>BET ALLOW(0/1):</label>
                                                <input type="number" name="bet_allow{{i}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.bet_allow" id="" class="form-control">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <button class="btn btn-update" (click)="onSubmit(item, '')">Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <app-loader class="full-overlay" *ngIf="submitted"></app-loader>
                            </accordion-group>
                        </accordion>
                    </div>
                    <app-loader class="no-overlay" *ngIf="!data"></app-loader>
                </div>
            </div>
        </div>
    </div>
  </div>